export default "__VITE_ASSET__BInkO8Jd__"